import { SYSTEM_PAGES } from "~/constants/page";

export default defineNuxtRouteMiddleware((to, from) => {
  try {
    const paths = to.path.split('/').slice(1);
    const navPaths = [''];

    if (!paths.length) throw new AbortError('Página não encontrada');

    const page = SYSTEM_PAGES.find((page) => page.route === paths[0]);
    if (!page) throw new AbortError('Página não encontrada');

    navPaths.push(page.route);

    if (page.dynamic) return;

    if (paths.length > 1) {
      const tabPath = paths.slice(1);

      const tabExists = findTabRoute(navPaths, page, tabPath);
      if (!tabExists) {
        if (page.tabs && page.tabs.length > 0) throw new AbortError('', buildPath(navPaths, page.tabs[0]));
        throw new AbortError('Página não encontrada');
      }
    }
    else {
      if (page.index) return;
      if (page.tabs && page.tabs.length > 0) throw new AbortError('', buildPath(navPaths, page.tabs[0]));
      throw new AbortError('Página não encontrada');
    }
  }
  // @ts-ignore
  catch (error: AbortError) {
    abortNavigation();
    if (error.message) warnToast(error.message);
    return navigateTo(error.redirect);
  }

});

const findTabRoute = (navPaths: string[], page: Page, paths: string[]): boolean => {
  if (!paths.length) return true;

  if (page.tabs && page.tabs.length > 0) {
    const subPage = page.tabs.find(tab => tab.route === paths[0]);
    if (subPage) {
      navPaths.push(subPage.route);
      return findTabRoute(navPaths, subPage, paths.slice(1));
    }
  }
  return false;
}

const buildPath = (paths: string[], lastPage?: Page): string => {
  if (lastPage && !paths.includes(lastPage.route)) paths.push(lastPage.route);
  return paths.join('/');
}